<script>
import { sharedData } from '../../../static/js/vue_specific/sharedData';
import { defineAsyncComponent } from 'vue';
const NewsPage = defineAsyncComponent(() =>
  import(
    /* webpackChunkName: "newsPage" */ '../../03-pages/NewsPage/NewsPage.vue'
  )
);
const CalendarPage = defineAsyncComponent(() =>
  import(
    /* webpackChunkName: "otherComponents" */ '../../03-pages/CalendarPage/CalendarPage.vue'
  )
);
const ImageGalleryBlock = defineAsyncComponent(() =>
  import(
    /* webpackChunkName: "otherComponents" */ '../../02-block_components/ImageGalleryBlock/ImageGalleryBlock.vue'
  )
);
const PersonalizedAreaBlock = defineAsyncComponent(() =>
  import(
    /* webpackChunkName: "personalizedAreaBlock" */ '../../02-block_components/PersonalizedAreaBlock/PersonalizedAreaBlock.vue'
  )
);
const EducationBlock = defineAsyncComponent(() =>
  import(
    /* webpackChunkName: "standaloneComponents" */ '../../02-block_components/EducationBlock/EducationBlock.vue'
  )
);
const CalendarBlock = defineAsyncComponent(() =>
  import(
    /* webpackChunkName: "standaloneComponents" */ '../../02-block_components/CalendarBlock/CalendarBlock.vue'
  )
);
const LoadMore = defineAsyncComponent(() =>
  import(
    /* webpackChunkName: "loadMore" */ '../../01-global_components/LoadMore/LoadMore.vue'
  )
);
const CartButton = defineAsyncComponent(() =>
  import(
    /* webpackChunkName: "cartButton" */ '../../01-global_components/CartButton/CartButton.vue'
  )
);
const PeriodBar = defineAsyncComponent(() =>
  import(
    /* webpackChunkName: "periodBar" */ '../../01-global_components/PeriodBar/PeriodBar.vue'
  )
);
const FileBrowserBlock = defineAsyncComponent(() =>
  import(
    /* webpackChunkName: "fileBrowserBlock" */ '../../02-block_components/FileBrowserBlock/FileBrowserBlock.vue'
  )
);

const BlogPage = defineAsyncComponent(() =>
  import(
    /* webpackChunkName: "blogPage" */ '../../03-pages/BlogPageContent/BlogPage.vue'
  )
);
const BlogPost = defineAsyncComponent(() =>
  import(
    /* webpackChunkName: "blogPost" */ '../../03-pages/BlogPostContent/BlogPost.vue'
  )
);
const ListOfLinks = defineAsyncComponent(() =>
  import(
    /* webpackChunkName: "listOfLinks" */ '../../06-listify-outputs/ListOfLinks/ListOfLinks.vue'
  )
);
const SaveAndListen = defineAsyncComponent(() =>
  import(
    /* webpackChunkName: "standaloneComponents" */ '../../01-global_components/SaveAndListen/SaveAndListen.vue'
  )
);

const LibraryBrowserBlock = defineAsyncComponent(() =>
  import(
    /* webpackChunkName: "libraryBrowserBlock" */ '../../02-block_components/LibraryBrowserBlock/LibraryBrowserBlock.vue'
  )
);

const ReminderBlock = defineAsyncComponent(() =>
  import(
    /* webpackChunkName: "reminderBlock" */ '../../02-block_components/ReminderBlock/ReminderBlock.vue'
  )
);



export default {
  props: ['component', 'componentProps'],
  data() {
    return {
      shared: sharedData,
      showModal: false,
    };
  },
  components: {
    NewsPage,
    CalendarPage,
    ImageGalleryBlock,
    PersonalizedAreaBlock,
    EducationBlock,
    CalendarBlock,
    LoadMore,
    CartButton,
    PeriodBar,
    FileBrowserBlock,
    BlogPage,
    BlogPost,
    ListOfLinks,
    SaveAndListen,
    LibraryBrowserBlock,
    ReminderBlock
  },
  // computed: {
  //   isSetAsFavourite: function () {
  //     if (document.querySelector("meta[name='pageId']")) {
  //       var currentPageId = document
  //         .querySelector("meta[name='pageId']")
  //         .getAttribute('content');
  //       for (var i = 0; i < this.shared.favourites.length; i++) {
  //         if (this.shared.favourites[i].pageId == currentPageId) {
  //           return true;
  //         }
  //       }
  //       return false;
  //     }
  //   },
  // },
  // methods: {
  //   addFavourite() {
  //     let page = getCurrentPage();
  //     page.index = -1;
  //     this.shared.favourites.push(page);
  //     fetch(this.shared.addUrl + '?pageId=' + page.pageId, {
  //       method: 'get',
  //     });
  //   },
  //   removeFavourite(pageId) {
  //     if (!pageId) {
  //       pageId = document
  //         .querySelector("meta[name='pageId']")
  //         .getAttribute('content');
  //     }
  //     this.shared.favourites = this.shared.favourites.filter(
  //       (v, i, a) => v.pageId !== pageId
  //     );
  //     fetch(this.shared.removeUrl + '?pageId=' + pageId, {
  //       method: 'get',
  //     });
  //   },
  // },
};
</script>
<template>
  <component :is="component" v-bind="componentProps"></component>
</template>
